module.exports = __webpack_public_path__ + "static/management-onboard-03833e0908d15fe0546821816a48c5d3.png";